import * as contactApi from "@rentiohq/shared-frontend/dist/redux/contact/contact.api";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { appendQueryParams } from "@rentiohq/shared-frontend/dist/utils/url.utils";
import { Loading, Modal } from "@rentiohq/web-shared/dist/components";
import { i18n } from "@rentiohq/web-shared/dist/utils";
import React from "react";

interface IProps {
  contactId: number;
  bankAccountId: number;
  dismissable: boolean;
  onSuccess: () => void;
  onClose: () => void;
}

export const CollectionFollowUpScaModal = (props: IProps) => {
  const { contactId, bankAccountId, dismissable, onSuccess, onClose } = props;

  // State
  const [isFetching, setIsFetching] = React.useState(false);
  const [scaUrl, setScaUrl] = React.useState<string | undefined>(undefined);

  // Data
  const fetchScaUrl = async () => {
    try {
      setIsFetching(true);

      const redirectUrl = appendQueryParams({
        path: window.location.href,
        queryParams: {
          scaCallbackContactId: contactId,
        },
      });

      const { data } = await contactApi.getScaUrl({
        contactId,
        bankAccountId,
        redirectUrl,
      });

      const { scaUrl, status, reason } = data;

      if (status === "OK") {
        showAlert({
          type: "success",
          message: reason || "SCA already ok",
        });

        onSuccess();

        return;
      }

      setScaUrl(scaUrl);
      setIsFetching(false);
    } catch (error) {
      showAlert({
        type: "error",
        message: "Something went wrong",
        error,
      });

      onClose();
    }
  };

  // Lifecycle
  React.useEffect(() => {
    fetchScaUrl();
  }, [contactId, bankAccountId]);

  // Render
  if (isFetching) {
    return (
      <Modal onClose={onClose} width="large">
        <Loading />
      </Modal>
    );
  }

  if (!scaUrl) {
    return null;
  }

  return (
    <Modal
      onClose={onClose}
      actions={[
        {
          content: getLocalizedText("system.continue"),
          appearance: "primary",
          size: "small",
          onClick: () => {
            window.open(scaUrl, "_self");
          },
        },
      ]}
      heading={getLocalizedText("payments.collection.follow_up.sca.title")}
      hasDismiss={dismissable}
      shouldCloseOnOverlayClick={dismissable}
      width="large"
    >
      {i18n.tm("payments.collection.follow_up.sca.info")}
    </Modal>
  );
};
